// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__mY6JZ","requiredAsterisk":"Info_requiredAsterisk__3VBpd"};